import React from "react";
import "./Nav.css";
import logo from './images/events/logo_one.png';


function Footer() {
  const year = new Date().getFullYear();

  return (<footer className="relative mt-24 overflow-hidden border-t border-neutral-200/60 bg-neutral-100 text-neutral-900 dark:border-neutral-800 dark:bg-black dark:text-neutral-100">
      <div className="relative w-full px-6 sm:px-8 lg:px-10 xl:px-14 pt-14 md:pt-20 pb-10 md:pb-14">
        <div className="pointer-events-none absolute inset-x-0 bottom-0 overflow-hidden">
          <p
            className="
              translate-y-[28%]
              select-none text-center
              text-[18vw] leading-none tracking-[-0.06em]
              text-neutral-100 dark:text-neutral-900
              whitespace-nowrap
            "
          >
            WEST LA
          </p>
        </div>

        <div className="relative grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-6 max-w-2xl">
            <div className="mb-5 flex items-center gap-4">
              <img
                src={logo}
                alt="West LA Portraits logo"
                className="h-10 w-auto object-contain sm:h-12"
              />
              <p className="text-[11px] uppercase tracking-[0.28em] text-neutral-500 dark:text-neutral-400">
                West LA Portraits
              </p>
            </div>

            <h2 className="max-w-[11ch] font-serif italic text-[2rem] leading-[0.95] tracking-[-0.04em] text-black dark:text-white sm:text-5xl lg:text-6xl">
              Portraits that stay with you.
            </h2>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6">
              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[0.22em] text-neutral-500 dark:text-neutral-400">
                  Contact
                </p>
                <div className="space-y-2 text-sm text-neutral-700 dark:text-neutral-300 md:text-[15px]">
                  <p>
                    <a
                      href="tel:+16468757574"
                      className="transition-colors duration-200 hover:text-neutral-950 dark:hover:text-pink-500"
                    >
                      +1 (646) 875-7574
                    </a>
                  </p>
                  <p>
                   <a
  href="mailto:westlaportraits@gmail.com"
  className="break-all transition-colors duration-200 hover:text-pink-500 dark:hover:text-pink-400"
>
  westlaportraits@gmail.com
</a>
                  </p>
                </div>
              </div>

              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[0.22em] text-neutral-500 dark:text-neutral-400">
                  Follow
                </p>
                <div className="space-y-2 text-sm text-neutral-700 dark:text-neutral-300 md:text-[15px]">
                  <p>
                    <a
                      href="https://www.instagram.com/westlaportraits/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition-colors duration-200 hover:text-neutral-950 dark:hover:text-white"
                    >
                      Instagram
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://www.linkedin.com/in/alejandroarmas66/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition-colors duration-200 hover:text-neutral-950 dark:hover:text-white"
                    >
                      LinkedIn
                    </a>
                  </p>
                </div>
              </div>

              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[0.22em] text-neutral-500 dark:text-neutral-400">
                  Based in
                </p>
                <div className="space-y-2 text-sm text-neutral-700 dark:text-neutral-300 md:text-[15px]">
                  <p>West Los Angeles</p>
                  <p>Available for portraits, families, and editorial sessions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-neutral-200/50 dark:border-neutral-800/60">
        <div className="flex w-full flex-col gap-2 px-6 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-8 md:py-5 lg:px-10 xl:px-14">
          <p className="text-[11px] uppercase tracking-[0.18em] text-neutral-500 dark:text-neutral-400 md:text-xs">
            © {year} West LA Portraits
          </p>

          <p className="text-[11px] uppercase tracking-[0.18em] text-neutral-500 dark:text-neutral-400 md:text-xs">
            All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;